<div class="page-title">
  <div [innerHTML]="'Regulatory.Title' | translate | safe:'html'" class="title"></div>
  <div [innerHTML]="'Regulatory.SubTitle' | translate | safe:'html'" class="sub-title"></div>
</div>

<div *ngIf="!featureService.newRegulatoryControl" class="row">

  <form [formGroup]="regulatoryControlForm">
    <div class="wrapper">
      <span [translate]="'regulatoryControlInfo'" class="additional-info col-xl-auto"></span>

      <section class="date-field col-xl-auto">
        <mat-radio-group aria-labelledby="regulatorycontroltoggle"
                         formControlName="isOn">
          <mat-radio-button (click)="switchRegulatoryControl()" [value]="true">
            <span [translate]="'toggleYes'">Yes</span>
          </mat-radio-button>
          <mat-radio-button (click)="switchRegulatoryControl()" [value]="false">
            <span [translate]="'toggleNo'">No</span>
          </mat-radio-button>
        </mat-radio-group>
      </section>

      <div *ngIf="regulatoryModel.regulatoryControl.status" class="col-xl-auto">
        <section class="col-xl-12">
          <mat-form-field [floatLabel]="'always'" appearance="outline">
            <input (change)="updateUser()"
                   formControlName="details"
                   matInput name="regulatorycontrol"
                   oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')">
          </mat-form-field>
        </section>
      </div>
    </div>
  </form>
</div>

<div *ngIf="featureService.newRegulatoryControl">
  <form [formGroup]="employeePubTradeForm">
    <div class="row align-items-center">
      <div class="wrapper">
        <span class="additional-info col-xl-auto" translate="EmployeePubTradeInfo"></span>
        <section class="data-field col-xl-auto">
          <mat-radio-group aria-labelledby="regulatorycontroltoggle" class="switch-radio"
                           formControlName="isOn">
            <mat-radio-button (click)="switchEmployeePubTrade()" [value]="true">
              <span [translate]="'toggleYes'" class="text-bold">Yes</span>
            </mat-radio-button>
            <mat-radio-button (click)="switchEmployeePubTrade()" [value]="false">
              <span [translate]="'toggleNo'" class="text-bold">No</span>
            </mat-radio-button>
          </mat-radio-group>
        </section>
      </div>
      <section *ngIf="regulatoryModel.employeePubTrade.status" class="data-field col-xl-auto">
        <div [innerHTML]="'employeePubTradeDetailsPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()"
                 formControlName="details"
                 matInput name="employeePubTradeDetails">
          <mat-error *ngIf="isRequiredField(employeePubTradeForm, 'details')">
            {{ 'employeePubTradeDetailsRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
  </form>

  <form [formGroup]="controlPubTradeForm">
    <div class="row align-items-center">
      <div class="wrapper">
        <span class="additional-info col-xl-auto" translate="ControlPubTradedInfo"></span>
        <section class="data-field col-xl-auto">
          <mat-radio-group aria-labelledby="regulatorycontroltoggle" class="switch-radio"
                           formControlName="isOn">
            <mat-radio-button (click)="switchControlPubTrade()" [value]="true">
              <span [translate]="'toggleYes'" class="text-bold">Yes</span>
            </mat-radio-button>
            <mat-radio-button (click)="switchControlPubTrade()" [value]="false">
              <span [translate]="'toggleNo'" class="text-bold">No</span>
            </mat-radio-button>
          </mat-radio-group>
        </section>
      </div>
      <section *ngIf="regulatoryModel.controlPubTrade.status" class="data-field col-xl-auto">
        <div [innerHTML]="'controlPubTradeDetailsPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()"
                 formControlName="details"
                 matInput name="controlPubTradeDetails">
          <mat-error *ngIf="isRequiredField(controlPubTradeForm, 'details')">
            {{ 'controlPubTradeDetailsRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
  </form>
</div>

<form [formGroup]="regulatoryAffiliationForm" class="regulatory-form row">
  <div class="wrapper">
    <span [translate]="'regulatoryAffiliationInfo'" class="additional-info col-xl-auto"></span>
    <section class="data-field col-xl-auto">
      <mat-radio-group aria-labelledby="regulatoryAffiliationToggle"
                       formControlName="isOn">
        <mat-radio-button (click)="switchAffiliationControl()" [value]="true">
          <span [translate]="'toggleYes'">Yes</span>
        </mat-radio-button>
        <mat-radio-button (click)="switchAffiliationControl()" [value]="false">
          <span [translate]="'toggleNo'">No</span>
        </mat-radio-button>
      </mat-radio-group>
    </section>
  </div>

  <div *ngIf="regulatoryModel.regulatoryAffiliation.status">
    <!--    <p [translate]="'regulatoryAffiliationDetails'" class="additional-info">-->
    <!--      Enter the stock symbol(s) of the company or companies, separated by commas-->
    <!--    </p>-->
    <div class="row">
      <section class="data-field col-xl-8">
        <div [innerHTML]="'regulatoryAffiliationDetailsPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()"
                 formControlName="details"
                 matInput
                 name="regulatoryaffiliation" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'details')">
            {{ 'regulatoryAffiliationDetailsRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="row">
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationRelationshipPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="updateUser()"
                      formControlName="relationship"
                      name="relationship">
            <mat-option value="Other">{{ 'Relationship.Other' | translate }}</mat-option>
            <mat-option value="Spouse">{{ 'Relationship.Spouse' | translate }}</mat-option>
            <mat-option value="Parent">{{ 'Relationship.Parent' | translate }}</mat-option>
            <mat-option value="Child">{{ 'Relationship.Child' | translate }}</mat-option>
            <mat-option value="Self">{{ 'Relationship.Self' | translate }}</mat-option>
          </mat-select>
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'relationship')">
            {{ 'regulatoryAffiliationRelationshipRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationPersonNamePlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()"
                 formControlName="personName"
                 matInput
                 name="regulatoryaffiliation" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'personName')">
            {{ 'regulatoryAffiliationPersonNameRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="row">
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationCompanyPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline">
          <input (change)="updateUser()"
                 formControlName="company"
                 matInput
                 name="regulatoryaffiliation" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'company')">
            {{ 'regulatoryAffiliationCompanyRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="row">
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationCountryPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="onCountryChanged()"
                      disableOptionCentering
                      formControlName="country"
                      name="addresscountry">
            <mat-select-trigger>
              <span *ngIf="getCountryCode(regulatoryModel.affiliationDetails.mailingCountry)" class="ml-auto">
                <img [default]="'/img/flags/undefined.png'"
                     class="small-flag-icon"
                     src="/img/flags/{{getCountryCode(regulatoryModel.affiliationDetails.mailingCountry)}}.png">
              </span>
              <span class="country-info"> {{ getTranslate(regulatoryModel.affiliationDetails.mailingCountry) }}</span>
            </mat-select-trigger>
            <mat-select-search #addresscountrySearch></mat-select-search>
            <mat-option *ngFor=" let country of filterCountryList(countryList, addresscountrySearch.filter)"
                        value="{{country.countryName}}">
              <img [default]="'/img/flags/undefined.png'" class="flag-icon"
                   src="/img/flags/{{country.countryCode}}.png">
              <span class="country-info">{{ country.countryTranslation }}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'country')">
            {{ 'regulatoryAffiliationCountryRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
      <section class="data-field col-lg-4">
        <div [innerHTML]="'state' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <mat-select (selectionChange)="updateUser()"
                      disableOptionCentering
                      formControlName="state" name="state">
            <mat-select-trigger>
              <span class="country-info">
                {{
                  getStateName(regulatoryModel.affiliationDetails.mailingCountry,
                    regulatoryModel.affiliationDetails.mailingState)
                }}</span>
            </mat-select-trigger>
            <mat-option *ngFor="let state of getStatesByCountry(regulatoryModel.affiliationDetails.mailingCountry)"
                        value="{{state.code}}">
              <span class="country-info">{{ state.name }}</span>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'state')">
            {{ 'stateRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="row">
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationCityPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <input (change)="updateUser()"
                 formControlName="city"
                 matInput
                 name="regulatoryaffiliation" oninput="this.value=this.value.replace(/[^a-zA-Z|-\s]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'city')">
            {{ 'regulatoryAffiliationCityRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="row">
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationPostalCodePlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <input (change)="updateUser()"
                 formControlName="postalCode"
                 matInput name="regulatoryaffiliation"
                 oninput="this.value=this.value.replace(/[^A-Za-z0-9_ ]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'postalCode')">
            {{ 'regulatoryAffiliationPostalCodeRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationAddressPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <input (change)="updateUser()"
                 formControlName="address"
                 matInput
                 name="regulatoryaffiliation" oninput="this.value=this.value.replace(/[^a-zA-Z0-9|-\s]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'address')">
            {{ 'regulatoryAffiliationAddressRequired' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
    <div class="row mb-5">
      <section class="data-field col-lg-4">
        <div class="label">
          <div [innerHTML]="'regulatoryAffiliationPhonePlaceholder' | translate | safe:'html'"></div>
          <span class="small">{{ 'phoneFormat' | translate }}</span>
        </div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <input (change)="updateUser()"
                 formControlName="phone" matInput
                 name="regulatoryaffiliation"
                 oninput="this.value=this.value.replace(/[^0-9]/g,'')" type="tel">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'phone')">
            {{ 'phoneRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="hasErrorField(regulatoryAffiliationForm, 'phone', 'phone')">
            {{ 'phoneNotValid' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
      <section class="data-field col-lg-4">
        <div [innerHTML]="'regulatoryAffiliationEmailPlaceholder' | translate | safe:'html'" class="label"></div>
        <mat-form-field [floatLabel]="'always'" appearance="outline" class="select">
          <input (change)="updateUser()"
                 formControlName="email"
                 matInput name="regulatoryaffiliation"
                 oninput="this.value=this.value.replace(/[^a-zA-Z|-@\s]/g,'')">
          <mat-error *ngIf="isRequiredField(regulatoryAffiliationForm, 'email')">
            {{ 'emailRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="hasErrorField(regulatoryAffiliationForm, 'email', 'email')">
            {{ 'emailNotValid' | translate }}
          </mat-error>
        </mat-form-field>
      </section>
    </div>
  </div>

  <div class="wrapper">
    <span [translate]="'politicalFriends'" class="additional-info col-xl-auto"></span>
    <section class="col-xl-auto data-field">
      <mat-radio-group [(ngModel)]="regulatoryModel.hasPoliticalFriends" [ngModelOptions]="{standalone: true}"
                       aria-labelledby="hasPoliticalFriendstoggle">
        <mat-radio-button (click)="switchHasPoliticalFriends()" [value]="true">
          <span [translate]="'toggleYes'">Yes</span>
        </mat-radio-button>
        <mat-radio-button (click)="switchHasPoliticalFriends()" [value]="false">
          <span [translate]="'toggleNo'">No</span>
        </mat-radio-button>
      </mat-radio-group>
    </section>
  </div>
</form>
